import { useCreateAdjustmentBase } from "./useCreateAdjustmentBase"

import {
  CreateInventoryLotBatchCorrectionAdjustmentDocument,
  type CreateInventoryLotBatchCorrectionAdjustmentMutation,
  type CreateInventoryLotBatchCorrectionAdjustmentMutationVariables,
  type CreateLotBatchCorrectionInput,
} from "@/graphql/codegen/graphql"

interface UseCreateLotCorrectionAdjustmentReturn {
  createAdjustment: (input: CreateLotBatchCorrectionInput, comment?: string, document?: File) => Promise<boolean>
  isCreating: boolean
}

export const useCreateLotCorrectionAdjustment = (): UseCreateLotCorrectionAdjustmentReturn =>
  useCreateAdjustmentBase<
    CreateInventoryLotBatchCorrectionAdjustmentMutation,
    CreateInventoryLotBatchCorrectionAdjustmentMutationVariables,
    CreateLotBatchCorrectionInput
  >({
    documentNode: CreateInventoryLotBatchCorrectionAdjustmentDocument,
    getOutput: (data) => data.inventoryAdjustment.lotBatchCorrection,
  })
